﻿var vm;
(function () {
    'use strict';
    var controllerId = 'progressDepotOrderCtrl';
    angular
        .module('app.controllers')
        .controller(controllerId, progressDepotOrderCtrl)

    progressDepotOrderCtrl.$inject = ['common', 'datacontext', '$http', '$scope', '$rootScope', '$state', '$stateParams', '$translate', '$window', '$timeout'];

    function progressDepotOrderCtrl(common, datacontext, $http, $scope, $rootScope, $state, $stateParams, $translate, $window, $timeout) {
        var config = common.config;

        vm = this;

        //Datepickers config
        $('#txtFromDate').datepicker({
            format: 'dd/mm/yyyy'
        });
        $('#txtToDate').datepicker({
            format: 'dd/mm/yyyy'
        });

        //Pagination config
        vm.totalItems = 0;
        vm.itemsPerPage = 10;
        vm.currentPage = 1;

        vm.carrierName = "";

        //dropdown movement type
        vm.listMovementType = [];

        vm.isAdmin = false;

        // dropdowns multiselect config
        vm.statusIndexModel = [];
        vm.statusIndexList = [{id:null, label:"Seleccione"}];
        vm.criteria = {depotId : null};
        vm.statusIndexListTexts = {};
        vm.statusIndexSettings = {
            smartButtonMaxItems: 0,
            smartButtonTextConverter: function (itemText, originalItem) {
                return itemText;
            }
        };

        vm.depotOrderList = [];
        vm.export == false;
        vm.fromdate = null;
        vm.todate = null;
        vm.carrierModel = {};
        vm.documenttypeList = [];
        vm.actiontypeList = [];
        vm.actiontypeList.push({ Id: 1, Code: "D", Name: "Gate In" }, { Id: 2, Code: "P", Name: "Gate Out" });
        vm.displayLoading = false;
        vm.displayInfoNoData = true;
        vm.disabledBtnSearch = false;
        vm.disabledBtnExport = false;
        vm.referenceno = "";
        vm.operationtypemovement = "";
        vm.actionTypeCode = "";
        vm.varyard = "";
        vm.varactiontype = {};
        vm.codeActionType = {};
        vm.isDocTypeDisabled = true;
        vm.isRefNoDisabled = true;
        vm.TruckerBPRoleCode = "TRU";

        function init() {
            setBasicInformation();
            common.activateController([vm.selectLabel = 'Seleccione', fnInitialReferenceData()])
                .then(function (data) {
                    $timeout(function () {
                        vm.listMovementType.unshift({ Id: 0, Name: vm.selectLabel });
                        vm.movementModel = vm.listMovementType[0];

                        vm.documenttypeList.unshift({ DocumentTypeId: 0, Code: "", Name: vm.selectLabel });
                        vm.vardocumenttype = vm.documenttypeList[0].DocumentTypeId;

                        vm.actiontypeList.unshift({ Id: 0, Name: vm.selectLabel });
                        vm.varactiontype = vm.actiontypeList[0].Id;
                    }, 500);
                });
        };

        function setBasicInformation() {
            var authData = common.localStorageService.get('authorizationData');
            var roleSelected = authData ? authData.userRole : "";
            vm.isAdmin = roleSelected === "COPAdminP" ? true : false;
            vm.varyard = authData.ModelRequester.CurrentYardId
        }

        function fnInitialReferenceData() {
            return datacontext.progressdepotorder.getFilters()
                .then(function (data) {
                    if (data) {
                        if (data.MovementType != null && data.MovementType.length > 0) {
                            angular.forEach(data.MovementType, function (movementType, key) {
                                vm.listMovementType.push(movementType);
                            });
                        }

                        if (data.Depot != null && data.Depot.length > 0) {
                            angular.forEach(data.Depot, function (depot, key) {
                                vm.statusIndexList.push({ id: depot.Id, label: depot.Name });
                                vm.statusIndexModel.push({ id: depot.Id, label: depot.Name });
                            });
                        }

                        vm.carrierName = data.Carrier;
                        vm.CarrierId = data.CarrierId;
                    }

                }, function (err) {
                    if (err.status)
                        toastr.error(err.info);
                });
        };

        function fnGetProgressDepotOrderList() {
            clearFilters();
            var criteria = fnGetParametersToSearchDepotOrder(vm.currentPage, vm.itemsPerPage);
            vm.displayLoading = true;
            vm.displayInfoNoData = false;
            vm.disabledBtnSearch = true;
            vm.disabledBtnExport = true;
            vm.depotOrderList = [];
            vm.totalItems = 0;

            return datacontext.progressdepotorder.getProgressDepotOrderList(criteria)
                .then(function (data) {
                    vm.disabledBtnSearch = false;
                    vm.displayLoading = false;
                    vm.disabledBtnExport = false;
                    if (data) {
                        if (angular.isDefined(data.DepotOrder) &&
                            data.DepotOrder != null &&
                            data.DepotOrder.length > 0) {
                            vm.depotOrderList = data.DepotOrder;
                            vm.totalItems = data.DepotOrder[0].TotalRegisters;
                            vm.export = true;
                        } else{
                            vm.displayInfoNoData = true;
                            vm.export = false;
                        }
                    }
                }, function (err) {
                    vm.export = false;
                    vm.disabledBtnSearch = false;
                    vm.disabledBtnExport = false;
                    vm.displayLoading = false;
                    vm.displayInfoNoData = true;
                    if (err.status)
                        toastr.error(err.info);
                });
        };

        function fnGetParametersToSearchDepotOrder(pageNumber, pageSize) {
            var criteria = {};
            var authData = common.localStorageService.get('authorizationData');
            criteria.carrierId = vm.CarrierId;
            criteria.yardId = fnGetYardSelected();
            criteria.operationTypeMovementId = angular.copy(vm.movementModel.Id);
            criteria.fromDate = fnConvertDateToSQLFormat(vm.fromdate);
            criteria.toDate = fnConvertDateToSQLFormat(vm.todate);
            criteria.pageNumber = parseInt(pageNumber);
            criteria.pageSize = parseInt(pageSize);
            criteria.userName = authData.username;
            criteria.languageId = authData.ModelRequester.DefaultLanguageId;
            criteria.referenceDocumentNo = $scope.selectedReferenceNo != null ? $scope.selectedReferenceNo.ReferenceDocumentNo : null;
            criteria.actionType = vm.actionTypeCode === "" ? null : vm.actionTypeCode;
            criteria.documentTypeId = vm.vardocumenttype == 0 ? null : vm.vardocumenttype;
            return criteria;
        };

        function fnGetCarrierSelected() {
            var carrierId = 0;
            if (vm.carrierModel.originalObject != undefined)
                carrierId = angular.copy(vm.carrierModel.originalObject.BusinessPartnerId);
            return carrierId;
        };

        function fnGetYardSelected() {
            var yardSelecteds = [];
            if (vm.criteria) {
                if(vm.criteria.depotId != null)
                    yardSelecteds.push(vm.criteria.depotId);
            }
            else{
                for (var i = 0, j = vm.statusIndexList.length; i < j; i++) {
                         yardSelecteds.push(vm.statusIndexList[i].id);
                }
            }
            // var yardSelecteds = [];
            // if (vm.statusIndexModel.length > 0) {
            //     for (var i = 0, j = vm.statusIndexModel.length; i < j; i++) {
            //         yardSelecteds.push(vm.statusIndexModel[i].id);
            //     }
            // }
            return yardSelecteds.toString();
        };

        function fnGetExportExcelForDepotOrder() {
            if(vm.export == true){
            var criteria = fnGetParametersToSearchDepotOrder(1, 2000);
            let url_ = config.basePaths.Base_Path_Resources + 'reportList/exportProgressDepotOrder';
            var authData = common.localStorageService.get('authorizationData');
            const fileName = 'DepotOrderProgress';
            var request = new XMLHttpRequest();
            request.open('POST', url_, true);
            request.setRequestHeader("Authorization", "Bearer " + authData.access_token);
            request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            request.setRequestHeader('ModelRequester', JSON.stringify(authData.ModelRequester));
            request.responseType = 'blob';

            request.onload = function (e) {
                if (this.status === 200) {
                    var blob = this.response;
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveBlob(blob, fileName);
                    }
                    else {
                        var downloadLink = window.document.createElement('a');
                        var contentTypeHeader = request.getResponseHeader("Content-Type");
                        downloadLink.href = window.URL.createObjectURL(new Blob([blob], { type: contentTypeHeader }));
                        downloadLink.download = fileName;
                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                        document.body.removeChild(downloadLink);
                    }
                }
            };
            request.send(JSON.stringify(criteria));
            }
            else{
                toastr.info($translate.instant('views.stocksummary.noDataToExport'));
                return;
            }
        };

        function fnClearDepotOrder() {
            var authData = common.localStorageService.get('authorizationData');
            var roleSelected = authData ? authData.userRole : "";

            //CARRIER
            if (roleSelected !== "CAR") {
                //clear line
                $scope.$broadcast('angucomplete-alt:clearInput', 'carrier');
                vm.selectedCarrierFn();
            }

            //clear depot
            vm.criteria.depotId =  null;
            vm.statusIndexModel = [];
            angular.forEach(vm.statusIndexList,
                function (val, key) {
                    vm.statusIndexModel.push({ id: val.id, label: val.label });
                });
            //clear movement type
            vm.movementModel = vm.listMovementType[0];

            //clear document type
            vm.vardocumenttype = vm.documenttypeList[0].DocumentTypeId;

            //clear action type
            vm.varactiontype = vm.actiontypeList[0].Id;

            //clear from date and to date
            vm.fromdate = null;
            vm.todate = null;
            $scope.selectedReferenceNo = null;
            vm.referenceno = null;

            //clear depot order list
            vm.depotOrderList = [];
            vm.displayInfoNoData = true;
            vm.totalItems = 0;

            vm.isDocTypeDisabled = true;
            vm.isRefNoDisabled = true;

            //clear pagination
            vm.currentPage = 1;
            vm.itemsPerPage = 20;

            //clear reference no
            cleanReferenceDocument();

            //Action Type
            vm.actionTypeCode = "";
        }
        vm.startDate = function () {
            $('#txtFromDate').focus();
        };

        vm.endDate = function () {
            $('#txtToDate').focus();
        };
        function fnConvertDateToSQLFormat(date) {
            var parseDate = null;
            if (date != undefined && date != '') {
                var splitDate = date.split("/");
                parseDate = splitDate[1] + '/' + splitDate[0] + '/' + splitDate[2];
            }
            return parseDate;
        }

        function getDocumentTypes() {
            datacontext.appointment.getDocumentTypes("M", vm.actionTypeCode).then(function (data) {
                vm.documenttypeList = data.DocumentTypes;
                vm.documenttypeList.unshift({ DocumentTypeId: 0, Code: "", Name: vm.selectLabel });
                vm.vardocumenttype = vm.documenttypeList[0].DocumentTypeId;

            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

        function getActionTypeCodeById(actionTypeId) {
            var actionType = $(vm.actiontypeList).filter(function (a, b) { return b.Id == actionTypeId })[0];
            return actionType ? actionType.Code : "";
        }

        function getDepotOrderSearchSetting() {
            var c = vm.actionTypeCode;
            var sPar = "AllowAppointmentCreationPickup";

            if (!c)
                c = "D";

            if (c == "D")
                sPar = "AllowAppointmentCreationDropOff";

            datacontext.appointment.getDepotOrderSearchSetting(sPar).then(function (data) {
                $(data).each(function (a, b) {
                    vm.operationtypemovement = vm.operationtypemovement + b.Name + ",";
                });

            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

        function cleanReferenceDocument() {
            vm.referenceno = "";
            $scope.selectedReferenceNo = "";
            $scope.$broadcast('angucomplete-alt:clearInput', 'referenceno');
            vm.selectedReferenceNoFn();
        }

        function clearFilters() {
            if (vm.referenceno === "" && $scope.selectedReferenceNo === "") {
                vm.vardocumenttype = 0;
                vm.isRefNoDisabled = true;
                cleanReferenceDocument();
            }
        }

        vm.getCarrierByName = function (name) {
            return datacontext.progressdepotorder.getCarrierByName(name);
        };

        vm.selectedCarrierFn = function (selected) {
            if (selected != undefined) {
                vm.carrierName = selected.originalObject.Name;
                vm.CarrierId = selected.originalObject.BusinessPartnerId;
            } else {
                vm.carrierName = null;
                vm.CarrierId = null;
            }
        };

        vm.exportProgressDepotOrder = function () {
            fnGetExportExcelForDepotOrder();
        };

        vm.searchDepotOrderList = function () {
            fnGetProgressDepotOrderList();
        };

        vm.pageChangeds = function () {
            fnGetProgressDepotOrderList();
        };

        vm.clear = function () {
            fnClearDepotOrder();
        };

        vm.selectActionType = function () {
            if (vm.varactiontype === 0) {
                vm.isDocTypeDisabled = true;
                vm.isRefNoDisabled = true;
                return;
            }

            cleanReferenceDocument();
            vm.actionTypeCode = getActionTypeCodeById(vm.varactiontype);
            getDocumentTypes();
            vm.isDocTypeDisabled = false;
        };

        vm.selectDocumentType = function () {
            if (vm.vardocumenttype === 0) {
                cleanReferenceDocument();
                vm.isRefNoDisabled = true;
                return;
            }

            cleanReferenceDocument();
            getDepotOrderSearchSetting();
            vm.isRefNoDisabled = false;
        };

        vm.selectedReferenceNoFn = function (selected) {
            if (selected) {
                vm.referenceno = selected;
                $scope.selectedReferenceNo = selected.originalObject;
            } else {
                vm.referenceno = "";
                $scope.selectedReferenceNo = "";
            }
        }

        $scope.getReferenceNumsDepotOrder = function (name) {
            return datacontext.appointment.getDepotOrderByRefDocNoCriteria(name, vm.vardocumenttype, vm.actionTypeCode, vm.varyard, vm.operationtypemovement);
        };

        init();

    }
})();